import { cloneDeep } from "lodash";

export const setActiveContentButtonLink = ({
  contents,
  activeContentId,
  buttonLink,
}) => {
  return contents.map((content) => {
    if (content.id === activeContentId) {
      content.buttonLink = buttonLink;
    }

    return cloneDeep(content);
  });
};

export default setActiveContentButtonLink;
